import { toResponseError, type QuizAddInput, type QuizAddSuccess, type QuizData } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useQuizCache } from './cache'

export function useAddQuiz(): AddHookResponse<QuizAddInput, QuizData> {
  const mutation = useTantalimMutation<QuizAddInput, QuizAddSuccess>({
    url: '/quiz/add',
  })
  const cache = useQuizCache()

  async function add(input: QuizAddInput): Promise<QuizData> {
    try {
      const { quiz } = await mutation.mutateAsync(input)
      cache.addItem(quiz)
      return quiz
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
